/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
 
import type { ApiRequestOptions } from './ApiRequestOptions';

type Resolver<T> = (options: ApiRequestOptions) => Promise<T>;
type Headers = Record<string, string>;

export type OpenAPIConfig = {
    BASE: string;
    VERSION: string;
    WITH_CREDENTIALS: boolean;
    CREDENTIALS: 'include' | 'omit' | 'same-origin';
    TOKEN?: string | Resolver<string> | undefined;
    USERNAME?: string | Resolver<string> | undefined;
    PASSWORD?: string | Resolver<string> | undefined;
    HEADERS?: Headers | Resolver<Headers> | undefined;
    ENCODE_PATH?: ((path: string) => string) | undefined;
};


// Function to get base URL dynamically based on environment
const getBaseUrl = (): string => {
    // If VITE_API_URL is explicitly set, always use it (production, CI, integration tests)
    if (import.meta.env.VITE_API_URL) {
        return import.meta.env.VITE_API_URL;
    }
    if (import.meta.env.MODE === 'production' || import.meta.env.PROD) {
        return typeof window !== 'undefined' ? window.location.origin : '';
    }
    // In development, use relative path to leverage Vite proxy
    return '';
};

// Function to get tenant headers
const getTenantHeaders = async (): Promise<Headers> => {
    const headers: Headers = {};
    
    // Add tenant header if available
    const storedTenant = localStorage.getItem('selectedTenant');
    if (storedTenant) {
        const tenant = JSON.parse(storedTenant);
        headers['X-Tenant-ID'] = tenant.uuid;
    }
    
    // Add authorization header if available. An expired or expiring token is refreshed first:
    // the generated client has no 401 retry, and its 401 used to end in a logout although the
    // refresh cookie was still valid (review round 5, finding 2.3).
    const { ensureFreshAccessToken } = await import('../../auth/ensureFreshAccessToken');
    const token = await ensureFreshAccessToken();
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    
    return headers;
};

export const OpenAPI: OpenAPIConfig = {
    BASE: getBaseUrl(), // Use the dynamic base URL
    VERSION: '1.0.0',
    WITH_CREDENTIALS: true, // Enable credentials to send HTTP-only cookies (refresh token)
    CREDENTIALS: 'include',
    TOKEN: undefined,
    USERNAME: undefined,
    PASSWORD: undefined,
    HEADERS: getTenantHeaders,
    ENCODE_PATH: undefined,
};
